import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 4H2v16h20V4zm-2 4l-8 5-8-5V6l8 5 8-5v2z"
}), 'MarkunreadSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/MarkunreadSharp.js
// module id = 4784
// module chunks = 2